import React from 'react';

const Rewards = () => {
  return (
    <div>
      <h1>Rewards Management</h1>
    </div>
  );
};

export default Rewards;
